import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAmexReportsRepository } from "../../../api/repositories/AmexReportsRepository";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import { handleDownload } from "../constants/ReportConstants";
import { useRecoilState } from "recoil";
import { STATE_TABLE_UPDATING } from "../constants/ReportRecoil";

interface Props {
    open: boolean;
    form?: any;
    title: string,
    body: string,
    leftButton: string,
    rightButton: string,
    viewNote?: boolean,
    leftFunction: () => void,
    rigthFunction?: () => void;
    onClose: () => void;
}

const ReportsModal = (props: Props) => {
    const { t } = useTranslation("finance", { keyPrefix: "payments.amex.transactions" });
    const [isChecked, setIsChecked] = useState(false);
    const [updating, setUpdating] = useRecoilState(STATE_TABLE_UPDATING);
    const { downloadReport } = useAmexReportsRepository();
    const { dispatchGlobalData } = useContext(GlobalContext);
    const onClose = () => {
        props.onClose();
    };

    async function download() {
        try {
            const response = await downloadReport(props.form.id, isChecked);
            handleDownload(props.form.name, response.result);
            setUpdating(true);
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t("snackbar.success-download"),
                        type: snackbarTypes.success,
                        show: true,
                        autoClose: true,
                    },
                },
            });
            onClose();
        } catch (error) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t('snackbar.error-download'),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true
                    }
                }
            });
        }
    }



    return (
        <Mui.Dialog
            open={props.open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    minWidth: "600px !important",
                    minHeight: "194px",
                    borderRadius: "4px",
                },
            }}
        >
            <Mui.DialogTitle>
                <Mui.Grid
                    container
                    alignItems="center"
                    alignContent="center"
                    direction="row"
                >
                    <Mui.Grid xs item>
                        <Mui.Stack direction="row" alignItems="center" gap={1}>
                            <MuiIcons.Info sx={{ color: '#C8017D' }} fontSize="small" />
                            <Mui.Box >{props.title}</Mui.Box>
                        </Mui.Stack>
                    </Mui.Grid>
                    <Mui.Grid
                        xs
                        item
                        sx={{
                            justifyContent: "flex-end",
                            display: "flex",
                        }}
                    >
                        <MuiIcons.Close
                            color="disabled"
                            fontSize="small"
                            onClick={onClose}
                        />
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogTitle>

            <Mui.Grid>

                <Mui.DialogContent>
                    <Mui.DialogContentText>
                        {props.body}
                    </Mui.DialogContentText>
                    <Mui.FormControlLabel
                        control={
                            <Mui.Checkbox
                                checked={isChecked}
                                onChange={() => setIsChecked(!isChecked)}
                            />
                        }
                        label={t("modal.updateDate")}
                    />
                </Mui.DialogContent>

                <Mui.DialogActions>
                    <Mui.Stack direction="row" spacing={2} p={1} mr={1}>
                        <Mui.Button
                            sx={{
                                maxWidth: "111px",
                                maxHeight: "48px",
                                minWidth: "111px",
                                minHeight: "48px",
                            }}
                            variant="outlined"
                            onClick={props.leftFunction}
                        >
                            <Mui.Typography
                                sx={{
                                    textTransform: "capitalize",
                                    fontWeight: 700,
                                    lineHeight: 1.25,
                                    color: "#C8017D",
                                }}
                                variant="subtitle1"
                            >
                                {props.leftButton}
                            </Mui.Typography>
                        </Mui.Button>

                        <Mui.Button
                            sx={{
                                maxWidth: "181px",
                                maxHeight: "48px",
                                minWidth: "111px",
                                minHeight: "48px",
                            }}
                            type={'button'}
                            variant="contained"
                            color="accent"
                            onClick={download}
                        >
                            <Mui.Typography
                                sx={{
                                    textTransform: "capitalize",
                                    fontWeight: 700,
                                    lineHeight: 1.25,
                                    color: 'white'
                                }}
                                variant="subtitle1"
                            >
                                {props.rightButton}
                            </Mui.Typography>
                        </Mui.Button>
                    </Mui.Stack>
                </Mui.DialogActions>
            </Mui.Grid>


        </Mui.Dialog>

    );
}

export default ReportsModal;